import script from "./communityApplyDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./communityApplyDetail.vue?vue&type=script&lang=ts&setup=true"

import "./communityApplyDetail.vue?vue&type=style&index=0&id=089b8eda&lang=less"

const __exports__ = script;

export default __exports__